import { cn } from "../../lib/utils";
import { CommandGroup, CommandItem } from "./command";
import { ShopLogo, Shop } from "./shop-logo";

export interface ShopsListProps {
  shops: Shop[];
  currentShop: Shop;
  onShopSelect: (shop: Shop) => void;
  heading?: string;
}

export default function ShopsList({
  shops,
  currentShop,
  onShopSelect,
  heading = "Dashboard",
}: ShopsListProps) {
  if (!currentShop || !shops) return null;

  return (
    <CommandGroup heading={heading}>
      {shops.map((shop) => (
        <CommandItem
          key={shop.id}
          value={`${shop.name}|${shop.id}`}
          onSelect={() => {
            if (shop.id !== currentShop.id) {
              onShopSelect(shop);
            }
          }}
          className={cn(
            "cursor-pointer text-sm gap-2 text-muted-forground font-medium hover:bg-accent hover:font-semibold",
            currentShop.id === shop.id ? "bg-accent font-semibold" : "",
          )}
        >
          <ShopLogo shop={shop} />
          <span className="flex-1">{shop.name}</span>
          {shop.isActive === false && (
            <span
              className="h-2 w-2 rounded-full bg-red-400 shrink-0"
              title="Shop inactif"
            />
          )}
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
